import { render, staticRenderFns } from "./zhichanyunForm.vue?vue&type=template&id=ce4f5236&scoped=true"
import script from "./zhichanyunForm.vue?vue&type=script&lang=js"
export * from "./zhichanyunForm.vue?vue&type=script&lang=js"
import style0 from "./zhichanyunForm.vue?vue&type=style&index=0&id=ce4f5236&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4f5236",
  null
  
)

export default component.exports